import type { ReactNode } from 'react'
import { cn } from '../../lib/shadcn/utils'

export type ChipTone = 'green' | 'red' | 'amber' | 'neutral' | 'brand'

const TONE_CLASSES: Record<ChipTone, string> = {
  green:
    'bg-emerald-100 text-emerald-800 border-emerald-200 dark:bg-emerald-950 dark:text-emerald-200 dark:border-emerald-800',
  red: 'bg-rose-100 text-rose-800 border-rose-200 dark:bg-rose-950 dark:text-rose-200 dark:border-rose-800',
  amber:
    'bg-amber-100 text-amber-800 border-amber-200 dark:bg-amber-950 dark:text-amber-200 dark:border-amber-800',
  neutral:
    'bg-muted text-muted-foreground border-border',
  brand:
    'bg-[hsl(var(--brand-soft))] text-[hsl(var(--brand-soft-foreground))] border-[hsl(var(--brand))]/30',
}

export function Chip({
  tone = 'neutral',
  icon,
  children,
  className,
}: {
  tone?: ChipTone
  icon?: ReactNode
  children: ReactNode
  className?: string
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-medium whitespace-nowrap',
        TONE_CLASSES[tone],
        className,
      )}
    >
      {icon}
      {children}
    </span>
  )
}
